import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { useCVStepFunctions } from '../../Hooks/useCVStepFunctions';
import { useCVStepConstants } from '../../Hooks/useCVStepConstants';

const CVSetup = React.createContext();

export function CVSetupProvider(props) {
    const { id } = useParams();
    const navigate = useNavigate();
    const { cv, loading, ...cvFunctionProps } = useCVStepConstants({ id });
    const [formData, setFormData] = React.useState({ cv: cv || {} });
    const { setCVBytes, updateCV: _updateCV } = useCVStepFunctions({ formData, setFormData, ...cvFunctionProps });

    // Set the formData based on the computed CV value
    React.useEffect(() => { setFormData((oldData) => ({
        ...(oldData || {}),
        cv: {...(cv || {})}
    })); }, [cv]);

    const updateCV = React.useCallback(() => {
        _updateCV().then(cvId => {
            if (cvId && cvId !== id) {
                navigate(`/cv-setup/${cvId}`);
            }
        });
    }, [_updateCV, navigate, id]);
    return (
        <CVSetup.Provider value={{ formData, setFormData, updateCV, setCVBytes, loading }}>
            {props.children}
        </CVSetup.Provider>
    );
}

export default function useCVSetupContext() {
    return React.useContext(CVSetup);
}